<div class="modal_dialog">
    <div class="modal_header">
      <h2>{{ title | translate }}</h2>
      <button class="btnn close_icon" type="button" [mat-dialog-close]> <mat-icon>close</mat-icon> </button>
    </div>
    <div class="modal_body">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="gap_m">
              <!-- Zone Form -->
              <div class="form_group w_100" *ngIf="formType === 'zone'">
                <mat-label class="required">{{ 'ZoneName' | translate }} <span class="astric">*</span></mat-label>
                <mat-form-field appearance="fill">
                  <input
                    matInput
                    placeholder="{{ 'EnterZoneName' | translate }}"
                    class="form_control"
                    type="text"
                    formControlName="name" />
                    <mat-error *ngIf="form.get('name')?.errors?.['required']">
                      {{ 'ZoneNameRequired' | translate }}
                    </mat-error>
                </mat-form-field>
              </div>

              <div class="form_group w_100" *ngIf="formType === 'zone'">
                <mat-label class="required">{{ 'ZoneAbbreviation' | translate }} <span class="astric">*</span></mat-label>
                <mat-form-field appearance="fill">
                  <input
                    matInput
                    placeholder="{{ 'EnterZoneAbbreviation' | translate }}"
                    class="form_control"
                    type="text"
                    formControlName="abbreviation" />
                    <mat-error *ngIf="form.get('abbreviation')?.errors?.['required']">
                      {{ 'ZoneAbbreviationRequired' | translate }}
                    </mat-error>
                </mat-form-field>
              </div>

              <!-- Level Form -->
              <div class="form_group w_100" *ngIf="formType === 'level'">
                <mat-label class="required">{{ 'LevelName' | translate }} <span class="astric">*</span></mat-label>
                <mat-form-field appearance="fill">
                  <input
                    matInput
                    placeholder="{{ 'EnterLevelName' | translate }}"
                    class="form_control"
                    type="text"
                    formControlName="level" />
                    <mat-error *ngIf="form.get('level')?.errors?.['required']">
                      {{ 'LevelNameRequired' | translate }}
                    </mat-error>
                </mat-form-field>
                <div class="zone-info" *ngIf="data.zone">
                  <small>{{ 'Zone' | translate }}: {{ data.zone.name }}</small>
                </div>
              </div>

              <!-- Shelve Form -->
              <div class="form_group w_100" *ngIf="formType === 'shelve'">
                <mat-label class="required">{{ 'ShelveNumber' | translate }} <span class="astric">*</span></mat-label>
                <mat-form-field appearance="fill">
                  <input
                    matInput
                    [placeholder]="'EnterNumberOnlyEG123' | translate"
                    class="form_control"
                    type="number"
                    formControlName="shelve" />
                    <mat-error *ngIf="form.get('shelve')?.errors?.['required']">
                      {{ 'ShelveNumberRequired' | translate }}
                    </mat-error>
                    <mat-error *ngIf="form.get('shelve')?.errors?.['pattern']">
                      {{ 'OnlyNumbersAreAllowed' | translate }}
                    </mat-error>
                </mat-form-field>
                <div class="shelve-info">
                  <small>{{ 'NoteBackendWillAutomaticallyAddSPrefixEGS123' | translate }}</small>
                </div>
                <div class="hierarchy-info" *ngIf="data.zone && data.level">
                  <small>{{ 'Zone' | translate }}: {{ data.zone.name }}</small><br>
                  <small>{{ 'Level' | translate }}: {{ data.level.level }}</small>
                </div>
              </div>

            </div>
            <div class="submit_btn">
              <button class="btnn btn_secondary" type="button" (click)="onCancel()">
                {{ 'Cancel' | translate }}
              </button>
              <button class="btnn btn_primary" type="submit" [disabled]="!form.valid">
                {{ 'Save' | translate }}
              </button>
            </div>
          </form>
    </div>
  </div>
  